// Calculate the points of a polygon that approximates a circle
interface LatLng {
  lat: number;
  lng: number;
}

interface LatLngWithMethods {
  lat(): number;
  lng(): number;
}

type CenterPoint = LatLng | LatLngWithMethods;

export const calculateCirclePolygon = (
  center: CenterPoint,
  radius: number,
  numPoints: number
): LatLng[] => {
  if (!center) {
    throw new Error('Center point is required');
  }

  const points: LatLng[] = [];
  const lat = typeof center.lat === 'function' ? center.lat() : center.lat;
  const lng = typeof center.lng === 'function' ? center.lng() : center.lng;

  if (typeof lat !== 'number' || typeof lng !== 'number') {
    throw new Error('Invalid center point coordinates');
  }

  for (let i = 0; i < numPoints; i++) {
    const angle = (i / numPoints) * (Math.PI * 2); // Full circle
    const pointLat = lat + (radius / 111300) * Math.sin(angle); // Convert meters to degrees
    const pointLng =
      lng +
      (radius / (111300 * Math.cos((lat * Math.PI) / 180))) * Math.cos(angle);
    points.push({ lat: pointLat, lng: pointLng });
  }

  return points;
};
